import { Redirect } from 'react-router';
import useAuthentication from 'hooks/useAuthentication';
import Logger from 'utilities/logger';

const withAuthProtection = () => Component => {
  const Wrapper = props => {
    const logger = Logger('with auth protection');
    const { login: authenticated, storage } = useAuthentication();
    if (authenticated) return <Component {...props} />;

    const redirectUrl = storage.getItem('redirect');
    if (!redirectUrl && window.location.pathname !== '/') {
      logger.debug({ redirect: window.location.href });
      storage.setItem('redirect', window.location.href);
    }

    return <Redirect push exact to="/login" />;
  };

  const name = Component.displayName || Component.name;
  Wrapper.displayName = `withAuthProtection(${name})`;
  return Wrapper;
};

export default withAuthProtection;
